import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let URL = "https://benefacto-backend.developer-ourbase-camp.com/api/";

export const HomeApi = createAsyncThunk("home/detail", async () => {
	try {
		const { data } = await axios.get(`${URL}home/get-home`);
		return data;
	} catch (err) {
		return err.message;
	}
});

export const AboutApi = createAsyncThunk("about/detail", async () => {
	try {
		const { data } = await axios.get(`${URL}aboutus/get-aboutus`);
		return data;
	} catch (err) {
		return err.message;
	}
});
